import { Injectable, inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalConfirmacaoComponent } from '../../components/redesign/modal-confirmacao/modal-confirmacao.component';

@Injectable({
  providedIn: 'root'
})
export class ValidacaoAlteracaoCampoService {
  private readonly dialog = inject(MatDialog);

  camposAlterado(){
    sessionStorage.setItem("camposAlterado", true.toString());
  }

  camposNaoAlterados(){
    sessionStorage.removeItem("camposAlterado");
  }

  isCamposAlteracao(): boolean {
    return sessionStorage.getItem("camposAlterado") != null;
  }

  monitorarAlteracoes(form: FormGroup, camposIgnorados: string[] = []) {
    Object.keys(form.controls)
      .filter(nome => !camposIgnorados.includes(nome))
      .forEach(nome => form.get(nome)!.valueChanges.subscribe(() => this.camposAlterado()));
  }

  confirmarFechamento(dialogRef: MatDialogRef<any>, mensagem = 'Deseja realmente cancelar?') {
    if (!this.isCamposAlteracao()) {
      dialogRef.close(false);
      return;
    }
    this.dialog.open(ModalConfirmacaoComponent, { data: { texto: mensagem } }).afterClosed().subscribe(confirmou => {
      if (confirmou) {
        dialogRef.close(false);
      }
    });
  }

  registrarFechamentoComConfirmacao(dialogRef: MatDialogRef<any>, mensagem = 'Deseja realmente cancelar?') {
    dialogRef.backdropClick().subscribe(() => this.confirmarFechamento(dialogRef, mensagem));
    dialogRef.keydownEvents().subscribe(evento => {
      if (evento.key === 'Escape') {
        this.confirmarFechamento(dialogRef, mensagem);
      }
    });
  }
}
